(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6227],{

/***/ 67317:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/un-available",
      function () {
        return __webpack_require__(41930);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 62573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ EmptyState; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44012);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16216);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _image_box_future__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58718);






var EmptyState = function(param) {
    var title = param.title, img = param.img, imgWidth = param.imgWidth, imgHeight = param.imgHeight, headTitle = param.headTitle, sx = param.sx, titleSx = param.titleSx;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            headTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: intl.formatMessage({
                        id: headTitle
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    textAlign: "center",
                    justifyContent: "center",
                    alignItems: "center"
                }, sx),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_box_future__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        img: img,
                        title: intl.formatMessage({
                            id: "alt.empty_icon"
                        }),
                        objectFit: "contain",
                        sx: {
                            width: imgWidth,
                            height: imgHeight
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        component: "h2",
                        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, titleSx),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            id: title
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 41930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_shared_empty_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62573);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);




var UnAvailable = function() {
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_empty_state__WEBPACK_IMPORTED_MODULE_1__/* .EmptyState */ .u, {
        title: "global.un_published.item",
        headTitle: "global.un_published.item",
        img: "/icons/booking/empty-session-image.svg",
        imgWidth: {
            mobile: "171px",
            tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q)(456.24)
        },
        imgHeight: {
            mobile: "149.32px",
            tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q)(398.19)
        },
        sx: {
            paddingX: {
                mobile: "16px",
                tablet: "0px"
            },
            height: {
                mobile: "calc(100vh - 56px)",
                mediumDesktop: "calc(100vh - 100px)"
            }
        },
        titleSx: {
            marginTop: {
                mobile: "16.68px",
                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q)(44.5)
            },
            fontSize: {
                mobile: "16px",
                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q)(20)
            },
            letterSpacing: {
                tablet: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_2__/* .pxToRem */ .Q)(0.1)
            },
            color: theme.palette.grey[50]
        }
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (UnAvailable);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(67317); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);